import type LoanDataService from '../../data-services/loan.data-service';
import type {IHttpResponse, IPromise} from 'angular';
import type {ActionResponse} from 'typings/portaro.be.types';
import {transferify} from 'shared/utils/data-service-utils';

export default class LoanReadyNoticeToSendQuestionController {
    public static readonly controllerName = 'LoanReadyNoticeToSendQuestionController';

    private submitPromise: (promise: IPromise<ActionResponse | IHttpResponse<ActionResponse>> | Promise<ActionResponse>) => any;

    public init(submitPromise: (promise: IPromise<ActionResponse | IHttpResponse<ActionResponse>> | Promise<ActionResponse>) => any): void {
        this.submitPromise = submitPromise;
    }

    /*@ngInject*/
    constructor(private loanDataService: LoanDataService
    ) {
    }

    public processLoan(loan: any, exemplar: any): void {
        this.submitPromise(this.loanDataService.processLoan(transferify(loan, true), transferify(exemplar, true)));
    }
}
